import classNames from 'classnames';
import { SelectButtons, FlexContainer } from 'components';
import { Select } from 'components';
import styles from './DurationSelect.module.scss';

const shortOptions = [
  { key: 3, value: '3 months' },
  { key: 6, value: '6 months' },
  { key: 12, value: '1 year' },
  { key: 24, value: '2 years' },
];

const fullOptions = new Array(36).fill(0).map((i, idx) => {
  const rawValue = idx + 1;
  const label = `${rawValue} month${rawValue > 1 ? 's' : ''}`;

  return {
    key: rawValue,
    value: label,
  };
});

/**
 * DurationSelect
 *
 * @return {JSX.Element}
 */
const DurationSelect = ({ className, name, value, onChange, reverse }) => {
  const handleChange = ({ target: { value: localValue } }) => {
    onChange({ target: { name, value: localValue * 1 } });
  };

  return (
    <FlexContainer
      className={classNames(
        styles.DurationSelect,
        className,
        DurationSelect.displayName
      )}
      column
      gap
    >
      <Select
        reverse={reverse}
        options={fullOptions}
        value={value}
        onChange={handleChange}
      />
      <SelectButtons
        options={shortOptions}
        value={value}
        onChange={handleChange}
      />
      <input type="hidden" name={name} value={value} onChange={() => {}} />
    </FlexContainer>
  );
};

DurationSelect.displayName = 'DurationSelect';

export default DurationSelect;
